"use client"
import ContentMarkdown from "@/components/modules/ContentOne/ContentMarkdown"
import Post from "@/components/Post"
import { CategoryType, KnowledgeType, SectionType } from "@/libs/types"
import clsx from "clsx"
import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import KnowledgeBreadcrumb from "./Breadcrumb"
import KnowledgeFooter from "./Footer"
import Submenu from "./Submenu"

interface KnowledgeDetailProps {
    locale: string
    knowledge: KnowledgeType
    previousPage?: KnowledgeType
    nextPage?: KnowledgeType
}

const KnowledgeDetail: React.FunctionComponent<KnowledgeDetailProps> = ({ locale, knowledge, previousPage, nextPage }) => {
    const { title, createdAt, thumb, content, sections, description, relevances } = knowledge.attributes

    const category: CategoryType | undefined = knowledge.attributes.category?.data
    return (
        <div className={clsx("bg-white post")}>
            <Container>
                <Row className={clsx("justify-content-center")}>
                    <Col md={8} xs={12}>
                        <div className="pt-10 mb-5 text-start">
                            <KnowledgeBreadcrumb locale={locale}
                                nameCategory={category?.attributes.name}
                                nameKnowledge={title} />
                            <h1 className="h2 fw-bold">{title}</h1>
                            <span className="text-muted">{new Date(createdAt).toDateString()}</span>
                        </div>
                        <Post.Thumbnail thumb={thumb} alt={title} />
                        {!!content && <ContentMarkdown locale={locale} content={content} />}
                        <div className={clsx(sections.length !== 0 ? "sections" : "d-none")}>
                            <Row className="justify-content-center">
                                {sections && sections.map((section: SectionType) => {
                                    return (
                                        <Post.Section key={section.id} locale={locale} section={section} />
                                    )
                                })}
                            </Row>
                        </div>
                        <hr className="my-0" />
                        <KnowledgeFooter locale={locale} previousPage={previousPage} nextPage={nextPage} category={category} />
                    </Col>
                    <Col md={3} xs={12}>
                        <Submenu locale={locale}
                            title={title}
                            description={description}
                            relevances={relevances}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default KnowledgeDetail